import { ODWebUtils } from '@mdpp/od-react-belt'
import React from 'react'
import { Redirect } from 'react-router-dom'
import { CenterWithFooterContainer } from '../common/layout/CenterWithFooterContainer'
import { LoginBox, LoginBoxDesignStyle } from '../login/LoginBox'
import { SiteUrls } from '../SiteUrls'
import { useHanmiManagerAppContext } from './context/HanmiManagerAppContext'

export const HanmiManagerLoginPage: React.FC = () => {
  const { login } = useHanmiManagerAppContext()

  const [redirect, setRedirect] = React.useState('')

  if (redirect) {
    return <Redirect to={redirect} />
  }

  const handleLogin = async (email: string, password: string) => {
    try {
      await login({ email, password })
      setTimeout(() => {
        setRedirect(SiteUrls.HanmiManager.Dashboard.Main)
      }, 100)
      return true
    } catch (ex) {
      ODWebUtils.showError(ex)
      return false
    }
  }

  return (
    <CenterWithFooterContainer>
      <LoginBox designStyle={LoginBoxDesignStyle.HanmiManager} onLogin={handleLogin} />
    </CenterWithFooterContainer>
  )
}
